import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography, useTheme } from "@material-ui/core";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { useSelector } from "react-redux";
import {
    checkMaterialsDeleteStatus,
    checkUploadedMaterialsStatus,
    getMaterialDetailsById,
    getOptionalUploadStatusById,
    getPreflightReportStatus,
} from "store/features/materialSpecs/specs";
import { PrintValidation, Validation } from "pages/MaterialSpecs/components/InfoPanel";
import { ThirdPartyTagForm } from "pages/MaterialSpecs/components/CreativesSection";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ProcessingHeader from "components/Accordion/ProcessingHeader/ProcessingHeader";
import BasicHeader from "pages/MaterialSpecs/components/BasicHeader/BasicHeader";
import { LoadingOverlay } from "components/LoadingOverlay/LoadingOverlay";

export const CustomerSummary = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { selectedMaterialSpecId, selectedMaterialId, isPrinted, setTab } = useMaterialSpecs();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    const isPreflightLoading = useSelector(getPreflightReportStatus);
    const isUploadingOptional = useSelector(getOptionalUploadStatusById(selectedMaterialSpecId));
    const isPreflightReportInvalid =
        !!materialDetails?.preflightReport?.errors?.length || !!materialDetails?.printPreflightReport?.haserrors;
    const isEmptyPrintMaterial = isPrinted && selectedMaterialId !== undefined && selectedMaterialId < 0;
    const isAnyMaterialUploading = useSelector(checkUploadedMaterialsStatus);
    const isPreflightReportAvailable =
        materialDetails?.printPreflightReport !== null || materialDetails?.preflightReport !== null;
    const isAnyMaterialDeleting = useSelector(checkMaterialsDeleteStatus);

    return (
        <LoadingOverlay
            active={isUploadingOptional || isAnyMaterialUploading || isAnyMaterialDeleting || isPreflightLoading}>
            {materialDetails && (
                <>
                    {!isEmptyPrintMaterial && (
                        <BasicHeader
                            bookedDimensions={materialDetails.bookedSize}
                            modificationDate={materialDetails.modificationDate}
                            dimensions={materialDetails.dimensions}
                        />
                    )}
                    <Box>
                        <Accordion
                            variant="outlined"
                            defaultExpanded
                            hidden={!isPreflightReportAvailable || isAnyMaterialUploading || isAnyMaterialDeleting}
                            style={{ backgroundColor: theme.palette.grey["100"], border: "none" }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <ProcessingHeader
                                    error={isPreflightReportInvalid}
                                    successLabel={t("campaign.customerSummary.label.validMaterial")}
                                    errorLabel={t("campaign.customerSummary.label.invalidMaterial")}
                                />
                            </AccordionSummary>
                            <AccordionDetails style={{ display: "block" }}>
                                {isPrinted ? (
                                    <PrintValidation />
                                ) : (
                                    <Validation disableInfo simplified showIcons={false} />
                                )}
                                <Box display="flex" justifyContent="flex-end">
                                    <Button variant="text" color="primary" onClick={() => setTab("VALIDATION")}>
                                        {t("buttons.label.fullReport")}
                                    </Button>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </>
            )}
            <Accordion
                variant="outlined"
                defaultExpanded
                style={{ backgroundColor: theme.palette.grey["100"], border: "none" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography component="div" variant="body1" color="textSecondary">
                        <Box fontWeight="fontWeightBold">{t("campaign.customerSummary.label.adServerProperties")}</Box>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ThirdPartyTagForm disableAccordion customerSummary enableOverlay={false} isOnCustomerTab />
                </AccordionDetails>
            </Accordion>
        </LoadingOverlay>
    );
};
